import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import SkeletonAgenda from '../components/SkeletonAgenda';
import { itineraryState, topicsState } from '../recoil';
import { ConferenceSchedule } from '../resources/data/itinerary-test-interfaces';
import { getItineraryFromSessionId } from '../services/api';
import VoiceItineraryHeader from '../components/VoiceItineraryHeader';
import VoiceItineraryAgenda from '../components/VoiceItineraryAgenda';
function SparkItineraryPage() {
  const [itinerary, setItinerary] = useRecoilState(itineraryState);
  const [qrCodeURL, setQRCodelURL] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [topics, setTopics] = useRecoilState(topicsState);

  const fullURL = window.location.href;

  // Extract the sessionId value using regular expressions
  const sessionIdMatch = fullURL.match(/sessionId=([^&]*)/);

  let sessionId = '';
  if (sessionIdMatch && sessionIdMatch.length > 1) {
    sessionId = sessionIdMatch[1];
  }

  useEffect(() => {
    getItinerary();
    console.log(sessionId);
  }, []);

  useEffect(() => {
    if (itinerary?.dates.length !== 0) {
      setIsLoading(false);
    }
  }, [itinerary]);

  const getItinerary = () => {
    if (sessionId) {
      getItineraryFromSessionId(sessionId).then((response) => {
        console.log(response.data);
        const responseData: ConferenceSchedule = response.data.itinerary;
        console.log(responseData);
        setItinerary(responseData);
        const topics = JSON.parse(response.data.topics);
        console.log(topics);
        setTopics(topics);
        setQRCodelURL(
          `${process.env.REACT_APP_URL}/spark-itinerary?sessionId=${sessionId}`
        );
      });
    }
  };

  return (
    <div className="ItineraryContainer p-2 md:p-5 relative flex min-h-screen w-screen flex-col  items-center gap-6  bg-gradient-to-br from-[#5570f1] to-[#9561e5]">
      <VoiceItineraryHeader qrCodeURL={qrCodeURL} />
      <div className="flex w-full pb-8 pl-[1rem] pr-[1rem]">
        {isLoading && <SkeletonAgenda count={8} />}
        {!isLoading && <VoiceItineraryAgenda itinerary={itinerary} />}
      </div>
    </div>
  );
}

export default SparkItineraryPage;
